import useMyPets from '~repositories/hooks/use-my-pets'
import useMyProfile from '~repositories/hooks/use-my-profile'

import { useNavigate } from '@tanstack/react-router'

import { setAppReset } from '~store/reset'
import AppPortalButton from './components/app-portal-button'
const SamsungSmartThingsPortal = () => {
  useMyProfile()
  useMyPets()
  const navigate = useNavigate()

  const handleAskDrTailVetClick = () => {
    navigate({
      to: '/samsung/smart-things/ask-a-vet',
      resetScroll: true,
    })
    setAppReset(false)
  }

  const handleMyConsultationsClick = () => {
    navigate({
      to: '/samsung/smart-things/my-consultations',
      resetScroll: true,
    })
    setAppReset(false)
  }

  return (
    <main className="w-full h-full flex flex-col items-center px-5 py-10 flex-gap-y-4">
      <AppPortalButton
        icon="consultation_sm"
        iconClassName="fill-primary-600"
        title="Ask a Dr.Tail vet"
        description={'Have a question about something?\nChat with a vet for quick answers.'}
        onClick={handleAskDrTailVetClick}
        buttonText="Start"
      />
      <AppPortalButton
        icon="question_sm"
        iconClassName="fill-tag-coral-orange"
        title="My questions"
        description={'Review the vet’s answers to your past questions.'}
        onClick={handleMyConsultationsClick}
        theme="yellow"
        buttonText="See my answers"
      />
    </main>
  )
}

export default SamsungSmartThingsPortal
